import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { routes } from "schemas/routes";

interface Props {
  onGoToScheduled: () => void;
}

const SCHEDULED_PATH = `/${routes.inboxScheduled}`;

export default function SuccessScreen({ onGoToScheduled }: Props) {
  return (
    <Box sx={{ textAlign: "center", py: 3 }}>
      <Typography
        sx={{
          fontSize: 22,
          fontWeight: 700,
          color: "text.primary",
          mb: 1,
        }}
      >
        Emails scheduled 🎉
      </Typography>
      <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
        You can review and edit them on the{" "}
        <Box
          component={RouterLink}
          to={SCHEDULED_PATH}
          onClick={onGoToScheduled}
          sx={{
            color: "primary.main",
            fontWeight: 600,
            textDecoration: "underline",
          }}
        >
          Scheduled tab
        </Box>{" "}
        of your inbox. It may take a minute for every email to appear.
      </Typography>
    </Box>
  );
}
